<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-row style="background-color: #f3f4f4">
      <el-col :xs="24" :md="3" style="  line-height: 40px;  font-size: 16px; color: #121212;  font-weight: bold;">
        <img style="width: 16px; height: 16px; margin-right: 12px" src="../../../assets/img/user-list.png"/>退款列表
      </el-col>
      <el-col :xs="24" :md="21">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right">
          <el-form-item>
            <el-button @click="exportHandle()" class="exportBtn" type="default" >{{ $t("export") }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              class="delBtn"
              type="danger"
              @click="deleteHandle()"
              >{{ $t("deleteBatch") }}</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <div class="mod-sys__user">
      <div class="search-form-area">
        <el-row style="border-bottom: 3px solid #f3f4f4; padding-bottom: 10px">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="margin-top: 20px; margin-left: 20px" label="企业名称:">
              <el-input v-model="dataForm.caName" placeholder="企业名称" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 20px; margin-left: 20px" label="退款人姓名:">
              <el-input v-model="dataForm.nameOfRefunder" placeholder="退款人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 20px; margin-left: 20px" label="退款人身份号码:">
              <el-input v-model="dataForm.idCardOfRefunder" placeholder="退款人身份号码" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 20px; margin-left: 20px">
              <el-button type="primary" @click="getDataList()">{{ $t("query") }}</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <div class="table-container">
        <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle" style="width: 100%" height="100%">
          <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
          <el-table-column label="序号" header-align="center" type="index" align="center"></el-table-column>
          <el-table-column prop="refundSn" label="退款单号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="caName" label="企业名称" header-align="center" align="center"></el-table-column>
          <el-table-column prop="nameOfRefunder" label="退款人姓名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="idCardOfRefunder" label="退款人身份证号码" header-align="center" align="center"></el-table-column>
          <el-table-column prop="isReceived" label="个人是否收款" header-align="center" align="center">
            <template slot-scope="scope">
              {{scope.row.isReceived == 0 ? '否' : '是'}}
            </template>
          </el-table-column>
          <el-table-column prop="refundAmount" label="退款金额" header-align="center" align="center">
            <template slot-scope="scope">
              {{scope.row.refundAmount ? (scope.row.refundAmount).toFixed(2) : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="退款时间" header-align="center" align="center"></el-table-column>
          <el-table-column prop="handledBy" label="经办人" header-align="center" align="center"></el-table-column>
          <el-table-column label="详情" fixed="right" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="fnOpenDetail(scope.row.id)"
                >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 查看 详情 -->
    <refundAdd ref="refundAdd"></refundAdd>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import { addDynamicRoute } from "@/router";
import refundAdd from "../user/refund-add.vue";
import qs from "qs";
import Cookies from "js-cookie";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        // pageList
        getDataListURL: "/sys/plat/refund/page",
        getDataListIsPage: true,
        deleteURL: "/sys/plat/refund/delete",
        deleteIsBatch: true,
        exportURL: "/sys/plat/refund/export",
      },
      role: Cookies.get("admin_role"),
      dataForm: {
        caName: "",
        nameOfRefunder: "",
        idCardOfRefunder: "",
      },
    };
  },
  components: {
    refundAdd
  },
  created() {},
  methods: {
    fnOpenDetail(id){
      this.$refs.refundAdd.dataForm.id = id;
      this.$refs.refundAdd.dataForm.isSee = true;
      this.$refs.refundAdd.init();
    },
  },
};
</script>
<style lang='scss' scoped>
.batchImport {
  /deep/ .el-list-enter-active,
  /deep/ .el-list-leave-active {
    transition: none;
  }

  /deep/ .el-list-enter,
  /deep/ .el-list-leave-active {
    opacity: 0;
  }
  /deep/ .el-upload-list {
    height: 40px;
  }
}

.mod-sys__user {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);

  .search-form-area {
    flex-shrink: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 20px;

    .el-table {
      flex: 1;
      overflow: auto;
    }

    .el-pagination {
      flex-shrink: 0;
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>